module.exports = __webpack_public_path__ + "static/media/RG_SN_1.da913102.png";